<template>
    <div class="swap-item-container">
        <img @click.stop="close" class="close-modal" :src="imageUrl('close-modal.png')"/>
        <div style="margin: 40vh auto;">
            <h3 v-show="!loading">Are you sure you want to unsave the {{itemType}}?</h3>
            <transition name="fade">
                <div v-show="loading" class="loading-overlay transparent">
                    <loader></loader>
                </div>
            </transition>
        </div>
        <div class="buttons-container">
            <div class="wtw-container small">
                <div @click.stop="confirm"
                     class="button pink full-width"
                >
                    Unsave it!
                </div>
                <div @click.stop="close" class="button outline full-width">Nevermind</div>
            </div>
        </div>
    </div>
</template>


<script>
    import Mixins from '../../mixins/mixins';
    import DeactivateScroll from "../../mixins/deactivate-scroll";
    import Loader from '../common/loader.vue';

    export default {
        props: ['itemType', 'close', 'confirm', 'loading'],
        components: {
            Loader
        },
        mixins: [Mixins, DeactivateScroll],
    }
</script>

<style>

</style>